const clustererMarkers = (theme: any) => {
    const clustererMarkers = [
        {
            url: theme?.assetMapsCluster?._url,
            height: theme?.assetMapsCluster?.umbracoHeight,
            width: theme?.assetMapsCluster?.umbracoWidth,
            textColor: theme?.clusterTextColor
        }
    ];

    return clustererMarkers;
};

export default clustererMarkers;